/**
 * Filter the entries in an object using a predicate that accepts the keys in the object
 */
export default function objectKeyFilter<T>(o: { [key: string]: T }, pred: (key: string, t: T) => boolean) {
  if (!o) {
    return o;
  }
  const onew: { [key: string]: T } = {};
  for (const key in o) {
    if (!pred(key, o[key])) {
      continue;
    }
    onew[key] = o[key];
  }
  return onew;
}
